/**
 * Compute SHA-256 hash of a File / Blob in the browser using the WebCrypto
 * SubtleCrypto API. Returns a lowercase hex string identical to Python's
 * `hashlib.sha256(content).hexdigest()` so backend duplicate checks match.
 *
 * Used by the BoardEditor's pre-flight duplicate check before committing
 * upload bytes to R2.
 */
export const sha256Hex = async (file) => {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const arr = Array.from(new Uint8Array(hashBuffer));
  return arr.map((b) => b.toString(16).padStart(2, '0')).join('');
};
